module.exports = __webpack_public_path__ + "static/media/Arrow-up-fill.ff1ac747.svg";